import React from 'react'
import { ToastOptions } from 'react-toastify'
import styled from 'styled-components'

import { COMMON_OPTIONS, ToastDispatcher } from './typesAndConstatnts'
import { ToastLayout } from '../ToastLayout'
import { dispatchOrUpdateToast } from './dispatchOrUpdateToast'
import SvgIcon from '../../../components/design-system/Icon/SvgIcon'
import { colors } from '../../../defaultTheme'
import './toast-styles.css'

const getOptions = (id?: string, customConfig?: ToastOptions): ToastOptions => ({
  ...COMMON_OPTIONS,
  style: { backgroundColor: colors.yellow },
  progressClassName: 'progress-bar-warning',
  ...customConfig,
  toastId: id
})

export const warning: ToastDispatcher = ({ title, content, id, config }) => {
  const color = colors.orange

  const layout = (
    <ToastLayout
      icon={
        <StyledIcon
          name="alert"
          width={23}
          height={23}
          primaryColor={color}
          secondaryColor={color}
        />
      }
      title={title}
      content={content}
    />
  )

  const options = getOptions(id, config)

  dispatchOrUpdateToast({ layout, options })
}

const StyledIcon = styled(SvgIcon)`
  margin-top: 3px;
`
